<template>
  <div class="rating-team-dropdown">
    <div
      class="rating-team-dropdown__row"
      :class="{ '-active-': isOpen, '-loading-': loading }"
      @click="toggle"
    >
      <div v-if="!loading" class="rating-team-dropdown__table">
        <div class="rating-team-dropdown__table-item -controll-">
          <p
            class="rating-team-dropdown__title"
            :class="`rating-team-dropdown__title--size-${sizeTitle}`"
          >
            {{ title }}
          </p>
          <Icon
            class="rating-team-dropdown__icon"
            icon="ui-arrow-down-alternative"
            :class="{ '-active-': isOpen }"
          />
        </div>
        <div class="rating-team-dropdown__table-item">
          <p class="rating-team-dropdown__table-text">
            {{ revenue }}
          </p>
        </div>
        <div class="rating-team-dropdown__table-item">
          <p class="rating-team-dropdown__table-text">
            {{ profit }}
          </p>
        </div>
      </div>
      <div v-else class="rating-team-dropdown__loader-wrap">
        <div class="rating-team-dropdown__loader ajax__line -round-" />
      </div>
    </div>
    <SlideUpDown
      class="rating-team-dropdown__body"
      :active="isOpen"
      :duration="300"
    >
      <slot />
    </SlideUpDown>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';

export default {
  components: {
    SlideUpDown
  },
  props: {
    title: {},
    sizeTitle: {
      type: String,
      default: 'md'
    },
    revenue: {},
    profit: {},
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isOpen: false
  }),
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      this.$emit('isOpen', this.isOpen);
    }
  }
};
</script>
